import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { getLastLogin } from '../services/api'; // Replace with your actual path
import "../css/navbar.css"; // Ensure this path is correct
import UrlDisplayModal from '../components/UrlDisplayModal';
const Navbar = ({ userRole, onLogout }) => {
  const location = useLocation();
  const isLoginPage = location.pathname === "/login";
  const [lastLogin, setLastLogin] = useState(null);
  const [error, setError] = useState(null);
  const [menuOpen, setMenuOpen] = useState(false);
  const [storedUserId, setStoredUserId] = useState(null);
  const [activityDropdownOpen, setActivityDropdownOpen] = useState(false);

  // New states for URL display modal
  const [showUrlModal, setShowUrlModal] = useState(false);
  const [currentUrlToDisplay, setCurrentUrlToDisplay] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [showCalculator, setShowCalculator] = useState(false);


  useEffect(() => {
    const fetchLastLogin = async () => {
      console.log(" username:", localStorage.getItem("username"));

      const storedUserId = localStorage.getItem("userId");
      setStoredUserId(storedUserId);

      if (!userRole || !storedUserId) {
        setLastLogin(null);
        setError(null);
        return;
      }
      try {
        const response = await getLastLogin(storedUserId);
        if (response.status === 200) {
          setLastLogin(response.data.lastLogin);
          setError(null);
        } else {
          console.error("Failed to fetch last login:", response.status, response.data);
          setLastLogin(null);
          setError("Failed to fetch last login. Please try again later.");
        }
      } catch (err) {
        console.error("Error fetching last login:", err);
        setLastLogin(null);
        setError("An error occurred. Please try again later.");
      }
    };
    fetchLastLogin();
  }, [userRole]);

  useEffect(() => {
    const adjustNavbarPosition = () => {
      const translateBar = document.querySelector(".goog-te-banner-frame");
      document.querySelector(".navbar").style.top = translateBar ? "80px" : "40px";
    };
    setTimeout(adjustNavbarPosition, 1000);
    const observer = new MutationObserver(adjustNavbarPosition);
    observer.observe(document.body, { childList: true, subtree: true });
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    const handleOutsideClick = (event) => {
      // Close main menu if click is outside navbar
      if (!event.target.closest(".navbar")) {
        setMenuOpen(false);
      }
      // Close activity dropdown if click is outside dropdown container
      if (!event.target.closest(".dropdown-container")) {
        setActivityDropdownOpen(false);
      }
    };
    if (menuOpen || activityDropdownOpen) { // Listen for clicks if either is open
      document.addEventListener("click", handleOutsideClick);
    } else {
      document.removeEventListener("click", handleOutsideClick);
    }
    return () => document.removeEventListener("click", handleOutsideClick);
  }, [menuOpen, activityDropdownOpen]);


  const toggleMenu = () => {
    setMenuOpen(!menuOpen);
  };

  const renderLastLogin = () => {
    if (lastLogin) {
      return <span className="last-login">Last Login: {lastLogin}</span>;
    }
    return error ? <span className="error-message">{error}</span> : null;
  };

  // Function to handle click on sub-menu items
  const handleSubMenuItemClick = (url, title) => {
    setCurrentUrlToDisplay(url);
    setModalTitle(title);
    setShowUrlModal(true);
    setActivityDropdownOpen(false); // Close the dropdown after selection
    setMenuOpen(false); // Close the main menu too
  };


  return (
    <>
      <nav className="navbar">
        <div className={`menu-toggle ${menuOpen ? "open" : ""}`} onClick={toggleMenu}>
          <div className="bar"></div>
          <div className="bar"></div>
          <div className="bar"></div>
        </div>
        <ul className={`nav-links ${menuOpen ? "active" : ""}`} onClick={(e) => {
          // Prevent closing main menu when clicking inside dropdown
          if (!e.target.closest(".dropdown-menu")) {
            setMenuOpen(false);
          }
        }}>
          {isLoginPage ? (
            <li><Link to="/">Home</Link></li>
          ) : (
            <>
              {!(localStorage.getItem('userRole')) && <li><Link to="/login">Login</Link></li>}
              {!(localStorage.getItem('userRole')) && <li><Link to="/">Home</Link></li>}
              {localStorage.getItem('userRole') === "PRIMARY" && (
                <>
                  <li><Link to="/change-password">Change Password</Link></li>
                  <li><Link to="/ownerdashboard">Dashboard</Link></li>
                  <li><Link to="/AgentForm">Register</Link></li>
                  <li><Link to="/BulkAgentForm">Bulk Register</Link></li>
                </>
              )}
              {localStorage.getItem('userRole') === "SECONDARY" && (
                <>
                  <li><Link to="/change-password">Change Password</Link></li>
                  <li><Link to="/ownerdashboard">Dashboard</Link></li>
                </>
              )}
              {localStorage.getItem('userRole') === "AGENT" && (
                <>
                  <li><Link to="/change-password">Change Password</Link></li>
                  <li><Link to="/agentdashboard">Dashboard</Link></li>
                  <li><Link to="/FileDownload">Generate PDF</Link></li>
                  <li><Link to="/GenerateLink">Generate Link</Link></li>
                  {/* Conditionally show Financial Planning link */}
                  {(localStorage.getItem("username") === "kapilchopra2k@gmail.com" || 
                    localStorage.getItem("username") === "jmanurkar@gmail.com") && (
                    <li><Link to="/financial-planning">Financial Planning</Link></li>
                  )}
                  {/* <li><Link to="/financial-planning">Financial Planning</Link></li>*/}
                  <li>
                  <a href={`/fincalc_AM.html?returnTo=${location.pathname}`} className="menu-link"  >
                  Financial Calculators
                    </a>
 
                  </li>

                  <li
                    className="dropdown-container"
                    onMouseEnter={() => setActivityDropdownOpen(true)}
                    onMouseLeave={() => setActivityDropdownOpen(false)}
                    onClick={(e) => {
                      e.stopPropagation(); // Prevent closing the main menu when clicking "Activity"
                      setActivityDropdownOpen(!activityDropdownOpen);
                    }}
                  >
                    <span>Activity</span>
                    {activityDropdownOpen && (
                      <ul className="dropdown-menu">
                        <li>
                          {/* Changed from <Link> to <span> and added onClick handler */}
                          <span onClick={() => handleSubMenuItemClick('/activity/structured', 'Structured Activity Link')}>Structured</span>
                        </li>
                        <li>
                          {/* Changed from <Link> to <span> and added onClick handler */}
                          <span onClick={() => handleSubMenuItemClick('/activity/unstructured', 'Unstructured Activity Link')}>Unstructured</span>
                        </li>
                      </ul>
                    )}
                  </li>

                </>
              )}

              {localStorage.getItem('userRole') && (
                <li>
                  <Link to="/" onClick={onLogout}>Logout</Link>
                </li>
              )}
              {localStorage.getItem('userRole') && <li>{renderLastLogin()}</li>}


            </>
          )}
          
        </ul>
      </nav>

      {/* Render the UrlDisplayModal conditionally */}
      {showUrlModal && (
        <UrlDisplayModal
          url={currentUrlToDisplay}
          title={modalTitle}
          onClose={() => setShowUrlModal(false)}
        />
      )}

  


    </>
  );
};

export default Navbar;